function headerReveal() {

    if (
        (window.scrollY < scrollPos) &&
        (window.scrollY > 300)
    ) { 
        //scroll up
        gsap.to(stickyHeader, {
            duration: 0.2,
            autoAlpha: 1,
            ease: "power3.linear"
        });
    } else {
        //scroll down
        gsap.to(stickyHeader, {            
            duration: 0.2,
            autoAlpha: 0,
            ease: "power3.linear"
        });
    }

    scrollPos = window.scrollY;

}
